export const RuleErrorCode = {
  SCHEMA_VERSION_REQUIRED: "CEO-RULE-001",
  AI_FACT_REQUIRES_CONFIRMATION: "CEO-RULE-002",
  FACT_REQUIRES_EVIDENCE_OR_CONFIRMATION: "CEO-RULE-003",
  INFERENCE_REQUIRES_FACT: "CEO-RULE-004",
  INFERENCE_SUPPORT_MUST_BE_FACT: "CEO-RULE-005",
  HYPOTHESIS_REQUIRES_TEST: "CEO-RULE-006",
  RECOMMENDATION_REQUIRES_BASIS: "CEO-RULE-007",
  CONFIDENCE_OUT_OF_RANGE: "CEO-RULE-008",
  CONFIDENCE_CANNOT_REPLACE_EVIDENCE: "CEO-RULE-009",
  PRIVATE_EXPORT_FORBIDDEN: "CEO-RULE-010",
  PRIVATE_TEXT_IN_EXTERNAL_SUMMARY: "CEO-RULE-011",
  EXTERNAL_SUMMARY_PRIVATE_REFERENCE: "CEO-RULE-012",
  EXTERNAL_SUMMARY_MUST_BE_DERIVED: "CEO-RULE-013",
  ONE_ACTIVE_CORRECTION_PER_DAY: "CEO-RULE-014",
  IDEA_MUST_START_IN_PARKING: "CEO-RULE-015",
  JOINT_CORRECTION_SOURCE_REQUIRED: "CEO-RULE-016",
  JOINT_CORRECTION_DERIVED_ONLY: "CEO-RULE-017",
  BOARD_CONTEXT_IMMUTABLE: "CEO-RULE-018",
  CONSTITUTION_USER_APPROVAL_REQUIRED: "CEO-RULE-019",
  CONSTITUTION_AI_MUTATION_FORBIDDEN: "CEO-RULE-020",
  PROMISE_REQUIRED_FIELDS: "CEO-RULE-021",
  DECISION_INFORMATION_REQUIRED: "CEO-RULE-022",
  CONFIRMED_DECISION_AUDIT_REQUIRED: "CEO-RULE-023",
  MAJOR_REVISION_AUDIT_REQUIRED: "CEO-RULE-024",
  UNCONFIRMED_INFERENCE_EXPORT_FORBIDDEN: "CEO-RULE-025",
  UNSUPPORTED_CONTRACT_VERSION: "CEO-CONTRACT-001",
  CONTRACT_SCHEMA_INVALID: "CEO-CONTRACT-002",
  CONTRACT_HASH_MISMATCH: "CEO-CONTRACT-003",
  IMPORT_LOCAL_NEWER_CONFLICT: "CEO-IMPORT-001",
  IMPORT_DUPLICATE: "CEO-IMPORT-002",
  IMPORT_SAME_DATE_CONFLICT: "CEO-IMPORT-003",
  RESTORE_CONFIRMATION_REQUIRED: "CEO-RESTORE-001",
  RESTORE_PREFLIGHT_FAILED: "CEO-RESTORE-002",
  MIGRATION_FAILED_SAFE: "CEO-DB-001",
  ONE_ACTIVE_REVIEW_PER_DAY: "CEO-REVIEW-001",
  REVIEW_TRUTH_REQUIRED: "CEO-REVIEW-002",
  REVIEW_DEVIATION_REQUIRED: "CEO-REVIEW-003",
  REVIEW_BUSINESS_IMPACT_REQUIRED: "CEO-REVIEW-004",
  CORRECTION_ACTION_REQUIRED: "CEO-REVIEW-005",
  CORRECTION_ACTION_TOO_ABSTRACT: "CEO-REVIEW-006",
  CORRECTION_VERIFICATION_REQUIRED: "CEO-REVIEW-007",
  REVIEW_STATEMENT_CONFIRMATION_REQUIRED: "CEO-REVIEW-008",
  TIMEZONE_CHANGE_CONFIRMATION_REQUIRED: "CEO-DATE-005",
} as const;

export type RuleErrorCode = (typeof RuleErrorCode)[keyof typeof RuleErrorCode];

export interface ValidationIssue {
  code: RuleErrorCode;
  message: string;
  path: string;
}

export class DomainInvariantError extends Error {
  readonly issues: ValidationIssue[];

  constructor(issues: ValidationIssue[]) {
    super(issues.map((issue) => `${issue.code}: ${issue.message}`).join("; "));
    this.name = "DomainInvariantError";
    this.issues = issues;
  }
}

export function assertNoIssues(issues: ValidationIssue[]): void {
  if (issues.length > 0) {
    throw new DomainInvariantError(issues);
  }
}
